<app-main-header [name_main]="titleheader" >
  @if(creating){
  <button [disabled]="for_save" mat-flat-button color="primary" [disabled]="!clientForm.valid"
    (click)="saveClients()">Guardar</button>
  }@else {
  <button class="check-btn" mat-flat-button (click)="openBottomSheet()"></button>
  <button mat-flat-button color="primary" [disabled]="!clientForm.valid || !for_save"
    (click)="saveClients()">Guardar</button>
  }

</app-main-header>

<hr>
<form [formGroup]="clientForm">

  <div class="clients-data">
    @for (d of formConfig; track d.label; let idx = $index, e = $even) {
    <mat-form-field appearance="outline" [ngStyle]="{ 'width': d.width, 'margin':d.margin}" *ngIf="d.type !== 'checkbox'">
      <mat-label>{{ d.label }}</mat-label>
      <input *ngIf="d.type != 'select'" matInput [formControlName]="d.controlName" [type]="d.type">

    </mat-form-field>
    <div *ngIf="d.type === 'checkbox'" class="checkbox-group">
      <mat-label>{{ d.label }}</mat-label>
      <div class="checkbox-options">
        <mat-checkbox [checked]="clientForm.get(d.controlName)?.value === true"
          (change)="clientForm.get(d.controlName)?.setValue(true)">
          Si
        </mat-checkbox>
        <mat-checkbox [checked]="clientForm.get(d.controlName)?.value === false"
          (change)="clientForm.get(d.controlName)?.setValue(false)">
          No
        </mat-checkbox>
      </div>
    </div>
    <div *ngIf="clientForm.get(d.controlName)?.errors?.['minlength'] && clientForm.get(d.controlName)?.touched">
      <mat-error style="margin: 0;">
        <small> El valor ingresado debe ser superior a 2 caracteres. </small>

      </mat-error>
    </div>
    }
    <div class="meta_content">
    <div class="header-metadata">
      <h3 style="font-weight: bold;">Metadata del cliente</h3>
      <button mat-flat-button color="primary" (click)="addClientsMetadata()" >Anadir nuevo</button>
    </div>
    
    <div class="metadata_form" formArrayName="client_metadata_schema">
      @for (row of client_metadata_schema.controls; track $index; let i = $index) {

      <div class="clients-metadata-row" [formGroupName]="i" >
        @for (meta of clientMetadataConfig; track $index; let col = $index) {
        <ng-container>
          <mat-form-field appearance="outline" [ngStyle]="{ 'width': meta.width, 'margin':meta.margin }"
            *ngIf="meta.type !== 'checkbox'&& meta.type !== 'select'">
            <mat-label>{{ meta.label }}</mat-label>
            <input matInput [formControlName]="meta.controlName" [type]="meta.type">
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="meta.type === 'checkbox'"> 
          {{ meta.label }} 
          <mat-checkbox [formControlName]="meta.controlName"
            [style.minWidth]="meta.width"> 
            </mat-checkbox> 
        </ng-container>

        <ng-container *ngIf="meta.type === 'select'">
          <mat-form-field appearance="outline" [ngStyle]="{ 'width': meta.width, 'margin':meta.margin }">
            <mat-label>{{ meta.label }}</mat-label>
          <mat-select [formControlName]="meta.controlName" [style.minWidth]="meta.width">
            <mat-option *ngFor="let option of typesOfValues" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
          </mat-form-field>
        </ng-container>

        }
      </div>
      <div class="delete-metadata-btn">
      <button mat-icon-button color="warn" (click)="deleteClientsMetadata($index)" matTooltip="Eliminar">
         <mat-icon>delete</mat-icon> 
        </button>
      </div>
      }

    </div>
  </div>
  </div>
  
    <!--   <div class="checkbox-group">
  <mat-label>¿Filtar producto?</mat-label>
  <div class="checkbox-options">
  <mat-checkbox 
  [checked]="clientForm.get('filter_products')?.value === true" 
  (change)="setFilterProductsValue(true)">
  Si
</mat-checkbox>
<mat-checkbox 
  [checked]="clientForm.get('filter_products')?.value === false" 
  (change)="setFilterProductsValue(false)">
  No
</mat-checkbox>

 </div>
 </div>
  <div class="checkbox-group">
  <mat-label>¿Validación única?</mat-label>
  <div class="checkbox-options">
  <mat-checkbox 
  [checked]="clientForm.get('validate_unique')?.value === true" 
  (change)="setValidateUniqueValue(true)">
  Si
</mat-checkbox>
<mat-checkbox 
  [checked]="clientForm.get('validate_unique')?.value === false" 
  (change)="setValidateUniqueValue(false)">
  No
</mat-checkbox>

  </div>
  </div>
<div class="checkbox-group">
<mat-label>¿Webhook activo?</mat-label>
<div class="checkbox-options">
<mat-checkbox 
  [checked]="clientForm.get('webhook_active')?.value === true" 
  (change)="setWebhookActiveValue(true)">
  Si
</mat-checkbox>
<mat-checkbox 
  [checked]="clientForm.get('webhook_active')?.value === false" 
  (change)="setWebhookActiveValue(false)">
  No
</mat-checkbox>

</div>
</div>
</div>
</form>
<div class="mission-parameters">
  <div class="title-btn">
      <div>  -->